import _EmojiEvents from "@mui/icons-material/EmojiEvents";
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import NavBarItem from 'app/components/navBar/NavBarItem';
import styled from 'styled-components';
import { COLORS } from '@fupa/fupa-uikit';
const StyledEmojiEvents = styled(_EmojiEvents).withConfig({
  componentId: "sc-53xwaa-0"
})(["&&&{color:", ";font-size:20;", "}"], props => props.selected ? COLORS.fupaSecondary : COLORS.darkerGrey, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fill: ", ";\n    padding-bottom: 0.75rem;\n    "])), props.selected ? COLORS.fupaSecondary : COLORS.lighterGrey));
export default function NavBarItemCompetitions(_ref) {
  let {
    isSelected,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(NavBarItem, _extends({
    isSelected: isSelected,
    follow: true,
    label: "Ligen"
  }, props, {
    "data-sentry-element": "NavBarItem",
    "data-sentry-component": "NavBarItemCompetitions",
    "data-sentry-source-file": "NavBarItemCompetitions.tsx"
  }), /*#__PURE__*/React.createElement(StyledEmojiEvents, {
    selected: isSelected,
    "data-sentry-element": "StyledEmojiEvents",
    "data-sentry-source-file": "NavBarItemCompetitions.tsx"
  }));
}